import { USER_SETTINGS } from "../../../constants/reducer_names";
import { createSlice } from "@reduxjs/toolkit";
import { resendResetLink } from "../../api/authentication";

const initialState = {
  settingsMenuValue: "",
  refreshNotification: false,
  isPlanUpgrade: false,
  companyPlanDetails: {}
};
const userSettingsSlice = createSlice({
  name: USER_SETTINGS,
  initialState,
  reducers: {
    updateMenuValue: (state, { payload }) => {
      state.settingsMenuValue = payload.settingsMenuValue;
    },
    setRefreshNotification: (state) =>{
      state.refreshNotification = !state.refreshNotification
    },
    setUpgradePlan: (state, { payload }) =>{
      state.isPlanUpgrade = payload
    },
    setCompanyPlanDetails: (state, { payload }) =>{
      state.companyPlanDetails = payload
    },
    reset: () => {},
  },
});
export const UserSettingsActions = userSettingsSlice.actions;
export default userSettingsSlice.reducer;
